import { getStoreId } from "$/hooks/use-store-information"
import servicePackageQueries from "$/lib/queries/service-package-queries"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/communication")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(serviceSettingsQueries.defaultMessages())
    const storeId = await getStoreId()
    if (storeId)
      queryClient.prefetchQuery(servicePackageQueries.detail(storeId))

    return {
      crumb: "alfred.settings.crumbs.communication",
    }
  },
})
